import axios from "axios";
import { refreshSessionOrLogout } from "./interceptors";
import { commonHeaders } from "./commonHeader";
import TokenService from "./tokenManager";
import { toast } from "react-toastify";
import { API_BASE_URL_ACCOUNT } from "config";

const accountClient = axios.create({
  baseURL: API_BASE_URL_ACCOUNT,
  headers: commonHeaders,
});

accountClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      if (config.headers) config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


accountClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Check for network error
    // if (!error.response) {
    //   toast.error('Kindly check your internet connection');
    // }
    return Promise.reject(error);
  }
);

accountClient.interceptors.response.use((res) => {
  return res;
}, refreshSessionOrLogout());

export default accountClient;






export const getTestAllDevice= async () => {
  return await axios({
    url: "https://digitallending.accessbankplc.com:9091",
    // headers: authHeader(),
    method: "get",
  }).then((response) => {
    return response.data;
  });
};